/**
 * Determines the correct route for viewing a note based on its processing flow.
 *
 * V2 (thread_id present): `/note/{id}` — streaming handles progress inline
 * V1 completed:           `/note/{id}` — safe to view directly
 * V1 processing/unknown:  `/status/{id}` — legacy polling page
 */
export function getNoteRoute({
  note_id,
  thread_id,
  status,
}: {
  note_id: string;
  thread_id?: string | null;
  status?: string | null;
}): string {
  if (thread_id) return `/note/${note_id}`;
  if (status === 'completed') return `/note/${note_id}`;
  return `/status/${note_id}`;
}
